// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"65e49984","86":"7be7988c","160":"5cf2e0a5","220":"d69a1177","972":"1e1e82b0","999":"06f7eb18"}[chunkId] + ".chunk.css";
};